import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Badge, Button, Card, CardBody, Container, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import TableContainer from "../../components/Common/TableContainer";
import { Link, useNavigate } from "react-router-dom";
import { DATABASE_EQUIPEMENT_FORM, DATABASE_EQUIPEMENT_EDIT, DATABASE_VEHICULE_FORM, DATABASE_VEHICULE_EDIT } from "../../routes/routeConstants";
import { useDispatch, useSelector } from "react-redux";
import { vehiculeActions } from "./vehiculeSlice";

function VehiculePage() {
    const { t } = useTranslation('translation');
    const dispatch = useDispatch();
    const [record, setRecord] = useState({ open: false, data: null });
    const { vehicules } = useSelector(state => state.vehicule);

    const breadcrumbItems = [
        { title: t('database'), link: "#" },
        { title: t('vehicule'), link: "#" },
    ];

    const navigate = useNavigate();

    useEffect(() => {
        load();
    }, []);

    const load = () => {
        let query = {
            criteria: {},
            page: 0,
            size: 5,
        };
        dispatch(vehiculeActions.search(query));
    }

    const downloadTemp = () => {
        let payload = {
            onSuccess: (response) => {
                var blob = new Blob([Uint8Array.from(atob(response), c => c.charCodeAt(0))], { type: "application/vnd.ms-excel" });
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = 'temp.xlsx';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            }
        }
        dispatch(vehiculeActions.downloadTemp(payload));
    }

    const handleDelete = (cellProps) => {
        setRecord({ open: true, data: cellProps });
    }

    const confirmDelete = () => {
        setRecord({ ...record, open: false });
        let payload = {
            id: record.data.id,
            onSuccess: () => {
                load();
            },
            onError: (error) => {
                console.log(error);
            },
        };
        dispatch(vehiculeActions.delete(payload));
    }

    const columns = useMemo(
        () => [
            {
                Header: t('vehiculef.marque'),
                accessor: "marque",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: t('vehiculef.modele'),
                accessor: "modele",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: t('vehiculef.carburant'),
                accessor: "carburant",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: t('vehiculef.nbrCylindres'),
                accessor: "nbrCylindres",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: t('vehiculef.puissFiscale'),
                accessor: "puissFiscale",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: t('vehiculef.reform'),
                accessor: (cellProps) => {
                    if(cellProps.reform === "ECONOMIQUE"){
                        return (
                            <React.Fragment>
                                <Badge className="bg-warning me-1">ECONOMIQUE</Badge>
    
                            </React.Fragment>
                        )
                    }else{
                        return (
                            <React.Fragment>
                                <Badge className="bg-danger me-1">TECHNIQUE</Badge>

                            </React.Fragment>
                        )
                    }
                    
                },
                disableFilters: true,
                filterable: false,
            },
            {
                Header: t('vehiculef.prixAchat'),
                accessor: "prixAchat",
                disableFilters: true,
                filterable: false,
            },

            {
                Header: t('action'),
                accessor: (cellProps) => {
                    return (
                        <React.Fragment>
                            <Link to={DATABASE_VEHICULE_EDIT.replace(":id", cellProps.id)} className="me-3 text-primary"><i className="mdi mdi-pencil font-size-18"></i></Link>
                            <Link onClick={() => handleDelete(cellProps)} className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                        </React.Fragment>
                    )
                },
                disableFilters: true,
                filterable: false,
            },
        ],
        []
    );

    const uploadData = (event) => {
        const files = event.target.files;
        const formData = new FormData();
        formData.append("file", files[0]);
        let payload = {
            formData: formData,
            onSuccess: () => {
                load()
            },
            onError: (error) => {
                console.log(error);
            },
        };
        dispatch(vehiculeActions.uploadData(payload));
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title={t('vehicule')} breadcrumbItems={breadcrumbItems} />
                    <Card>
                        <CardBody>
                            <TableContainer
                                canUpload={true}
                                withPages={true}
                                columns={columns || []}
                                data={vehicules ?? []}
                                isPagination={false}
                                isAddVehiculeList={true}
                                canDownloadtemp={true}
                                customPageSizeOptions={true}
                                iscustomPageSize={false}
                                handleVehiculeClick={() => navigate(DATABASE_VEHICULE_FORM)}
                                handleDownloadTemp={() => downloadTemp()}
                                handleUpload={uploadData}
                                isBordered={false}
                                customPageSize={10}
                            />
                        </CardBody>
                    </Card>
                </Container>
            </div>
            <Modal
                isOpen={record.open}
                toggle={() => setRecord({ ...record, open: false })}
                backdrop="static"
            >
                <ModalHeader toggle={() => setRecord({ ...record, open: false })}>
                    {t('text.confirmation')}
                </ModalHeader>
                <ModalBody>
                    <p>
                        {t('text.msgDelete')}
                    </p>
                    <ModalFooter>
                        <Button type="button" color="light" onClick={() => setRecord({ ...record, open: false })}>{t('actions.close')}</Button>
                        <Button type="button" color="primary" onClick={confirmDelete}>{t('actions.confirm')}</Button>
                    </ModalFooter>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}

export default VehiculePage;
